import { call, put } from 'redux-saga/effects';

import * as actNotif from '../../actions/notifications';
import * as action from '../../actions';

import * as auth from '../../api/auth';
import { assertErrorHasMessage } from '../../utils/assert';

export function* getProfile(params: any = {}, ignoreCache = false) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(auth.getProfile, params, ignoreCache);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}
